<template>
  <div class="block-calculate__preloader" v-if="!bool_showApp">
    <div class="loader">Loading...</div>
    <p class="preloader_text">Калькулятор загружается</p>
  </div>
</template>

<script>
export default {
  name: "preloader",
  props: {},
  computed: {
    bool_showApp() {
      return this.$store.state.bool_showApp;
    },
  },
  methods: {},
  mounted: function () {
    this.$store.commit("showApp");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*PRELOADER*/
.loader,
.loader:after {
  border-radius: 50%;
  width: 25px;
  height: 25px;
}
.loader {
  margin-right: 10px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 2px solid rgba(135, 135, 135, 0.2);
  border-right: 2px solid rgba(135, 135, 135, 0.2);
  border-bottom: 2px solid rgba(135, 135, 135, 0.2);
  border-left: 2px solid #878787;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.block-calculate__preloader {
  background: #f9f9f9;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

p.preloader_text {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 24px;
  margin: 0;
}
/*END PRELOADER*/
</style>
